import BaseService from "@/services/BaseService";
import * as URI from "../masters/constant";

const action = {

  /** Sales Hierarchy Master*/
  async salesHierarchyMasterDropDownAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_DROPDOWN;
    const resp = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesHierarchyMasterDropDown", resp.data.data);
    return resp.data.data;
  },
  async salesHierarchyMasterListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesHierarchyMasterList", response.data);
    return response.data;
  },
  async salesHierarchyMasterCreateAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SALE_HIERARCHY_MASTER_SAVE,
      payload
    );
    return response;
  },
  async salesHierarchyMasterDeleteAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_DELETE.replace(
      "{roleMasterId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response;
  },

  /** Sales Hierarchy Configuration*/
  async salesHierarchyMasterConfigurationGeoElementAction({ commit }, payload) {
    const url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_GEO_ELMENT.replace(
      "{division}",
      payload.division
    ).replace("{channelIds}", payload.channelIds);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setMasterGeoElement", response.data.data.geoElements);
    return response.data.data.geoElements;
  },
  async configurationDivisionHoldAction({commit}, payload) {
    commit("setConfigurationDivisionHold", payload);
  },
  async updateGeoElementAction({commit}, payload) {
    commit("setMasterGeoElement", payload);
  },
  async salesHierarchyMasterConfigurationListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesHierarchyMasterConfigurationList", response.data);
    return response.data;
  },
  async salesHierarchyMasterConfigurationDeleteAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_DELETE.replace(
      "{roleMasterId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response;
  },
  async salesHierarchyMasterConfigurationCreateAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SALE_HIERARCHY_MASTER_CONFIGURATION_SAVE,
      payload
    );
    return response;
  },
  async salesHierarchyMasterConfigurationSubmitAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_SUBMIT
    .replace("{configId}", payload.configId)
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response;
  },

 async salesHierarchyMasterConfigurationDTLLineItemListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
    .replace("{pageSize}", payload.page.pageSize)
    .replace("{value}", payload.sord.value)
    .replace("{sortOrder}", payload.sord.__sortOrder)
    .replace("{hdrId}", payload.hdrId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async salesHierarchyMasterConfigurationDTLLineItemDeleteAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_DELETE.replace(
      "{roleMasterId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response;
  },
  async salesHierarchyMasterConfigurationDTLLineItemCreateAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SALE_HIERARCHY_MASTER_CONFIGURATION_DTL_LINE_ITEM_SAVE,
      payload
    );
    return response;
  },
  async salesHierarchyDtlElemetDisableAction({commit}, payload) {
    commit("setSalesHierarchyDtlElemetDisable", payload);
  },

  /** Sales Hierarchy Upload*/

  async salesHierarchyMasterUploadListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setSalesHierarchyMasterUploadList", response.data);
    return response.data;
  },
  async salesHierarchyMasterUploadDeleteAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_DELETE.replace(
      "{ids}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response;
  },
  async salesHierarchyMasterUploadCreateAction({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.SALE_HIERARCHY_MASTER_UPLOAD_SAVE,
      payload
    );
    return response;
  },

  async salesHierarchyMasterUploadLineItemListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_LINE_ITEM_LIST
    .replace("{hdrId}", payload.hdrId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async salesHierarchyMasterUploadLineItemTemplateDownloadAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_LINE_ITEM_TEMPLATE_DOWNLOAD.replace("{hrdId}", payload);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },

  // Sale Role Info
  async salesHierarchyMasterUploadRoleInfoListAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_ROLE_INFO_LIST
    .replace("{id}", payload.id);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },

  async salesHierarchyMasterUploadRoleInfoImportExcelAction({ commit }, payload) {
    let url = URI.SALE_HIERARCHY_MASTER_UPLOAD_ROLE_INFO_IMPORT_EXCEL
    .replace("{id}", payload.id);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
};

export default action;
